import * as React from 'react';

const SvgLockIcon = (props: React.SVGAttributes<SVGElement>) => (
  <svg width="1em" height="1em" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M6.909 22.093h10.23c1.413 0 2.109-.696 2.109-2.236v-7.9c0-1.392-.57-2.099-1.751-2.215V7.137c0-4.008-2.668-5.938-5.474-5.938s-5.474 1.93-5.474 5.938v2.637c-1.097.169-1.751.865-1.751 2.183v7.9c0 1.54.696 2.236 2.109 2.236ZM8.575 6.948c0-2.457 1.561-3.807 3.449-3.807 1.877 0 3.449 1.35 3.449 3.807v2.774l-6.898.011z"
    />
  </svg>
);
export default SvgLockIcon;
